const TestWeatherEvents = {
  "date": "2018-05-02T18:25:47.4598775-05:00",
  "Alert": [
    {
      "type": "Severe Thunderstorm Warning",
      "IssueAt": "2018-05-02T18:01:00",
      "ExpiresAt": "2018-05-02T18:45:00",
      "AffectedAreas": {
        "Area": {
          "id": "Washita, OK"
        }
      },
      "AlertTextShort": {
        "section": "Severe Thunderstorm Warning in effect until May 2 at 6:45PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "The National Weather Service in Norman has issued a * Severe Thunderstorm Warning for... Southeastern Washita County in western Oklahoma... West central Caddo County in southwestern Oklahoma... Northeastern Kiowa County in southwestern Oklahoma... * Until 645 PM CDT"
      }
    },
    {
      "type": "Severe Thunderstorm Warning",
      "IssueAt": "2018-05-02T18:00:00",
      "ExpiresAt": "2018-05-02T18:45:00",
      "AffectedAreas": {
        "Area": [
          {
            "id": "Major, OK"
          },
          {
            "id": "Garfield, OK"
          },
          {
            "id": "Noble, OK"
          },
          {
            "id": "Blaine, OK"
          },
          {
            "id": "Kingfisher, OK"
          }
        ]
      },
      "AlertTextShort": {
        "section": "Severe Thunderstorm Warning in effect until May 2 at 6:45PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "The National Weather Service in Norman has issued a * Severe Thunderstorm Warning for... Northwestern Kingfisher County in central Oklahoma... West central Noble County in northern Oklahoma... Northeastern Blaine County in northwestern Oklahoma... Garfield County in northern Oklahoma..."
      }
    },
    {
      "type": "Severe Thunderstorm Warning",
      "IssueAt": "2018-05-02T18:15:00",
      "ExpiresAt": "2018-05-02T19:00:00",
      "AffectedAreas": {
        "Area": {
          "id": "Cotton, OK"
        }
      },
      "AlertTextShort": {
        "section": "Severe Thunderstorm Warning in effect until May 2 at 7:00PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "The National Weather Service in Norman has issued a * Severe Thunderstorm Warning for... Southwestern Comanche County in southwestern Oklahoma... West central Cotton County in southwestern Oklahoma... Tillman County in southwestern Oklahoma... Northwestern Wichita County in northern Texas..."
      }
    },
    {
      "type": "Severe Thunderstorm Warning",
      "IssueAt": "2018-05-02T17:58:00",
      "ExpiresAt": "2018-05-02T19:00:00",
      "AffectedAreas": {
        "Area": [
          {
            "id": "Kiowa, OK"
          },
          {
            "id": "Tillman, OK"
          },
          {
            "id": "Comanche, OK"
          },
          {
            "id": "Caddo, OK"
          }
        ]
      },
      "AlertTextShort": {
        "section": "Severe Thunderstorm Warning in effect until May 2 at 7:00PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "The National Weather Service in Norman has issued a * Severe Thunderstorm Warning for... Comanche County in southwestern Oklahoma... Southwestern Caddo County in southwestern Oklahoma... Southeastern Kiowa County in southwestern Oklahoma... North central Tillman County in southwestern Oklahoma..."
      }
    },
    {
      "type": "Severe Thunderstorm Warning",
      "IssueAt": "2018-05-02T18:16:00",
      "ExpiresAt": "2018-05-02T18:45:00",
      "AffectedAreas": {
        "Area": [
          {
            "id": "Canadian, OK"
          },
          {
            "id": "Grady, OK"
          }
        ]
      },
      "AlertTextShort": {
        "section": "Severe Thunderstorm Warning in effect until May 2 at 6:45PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "...A SEVERE THUNDERSTORM WARNING REMAINS IN EFFECT UNTIL 645 PM CDT FOR NORTHWESTERN GRADY...NORTHEASTERN CADDO AND SOUTHWESTERN CANADIAN COUNTIES... At 615 PM CDT, a severe thunderstorm was located near Binger, moving northeast at 25 mph. HAZARD...Golf ball size hail and 60 mph wind gusts."
      }
    },
    {
      "type": "Tornado Watch",
      "IssueAt": "2018-05-02T17:10:00",
      "ExpiresAt": "2018-05-02T22:00:00",
      "AffectedAreas": {
        "Area": [
          {
            "id": "Kay, OK"
          },
          {
            "id": "Noble, OK"
          },
          {
            "id": "Logan, OK"
          },
          {
            "id": "Payne, OK"
          },
          {
            "id": "Oklahoma, OK"
          },
          {
            "id": "Lincoln, OK"
          },
          {
            "id": "McClain, OK"
          },
          {
            "id": "Cleveland, OK"
          },
          {
            "id": "Pottawatomie, OK"
          },
          {
            "id": "Garvin, OK"
          }
        ]
      },
      "AlertTextShort": {
        "section": "Tornado Watch in effect until May 2 at 10:00PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "THE NATIONAL WEATHER SERVICE HAS EXTENDED TORNADO WATCH 62 TO INCLUDE THE FOLLOWING AREAS UNTIL 10 PM CDT THIS EVENING IN OKLAHOMA THIS WATCH INCLUDES 10 COUNTIES IN CENTRAL OKLAHOMA CLEVELAND LINCOLN LOGAN MCCLAIN OKLAHOMA PAYNE"
      }
    },
    {
      "type": "Tornado Watch",
      "IssueAt": "2018-05-02T17:10:00",
      "ExpiresAt": "2018-05-02T22:00:00",
      "AffectedAreas": {
        "Area": [
          {
            "id": "Tillman, OK"
          },
          {
            "id": "Comanche, OK"
          },
          {
            "id": "Stephens, OK"
          },
          {
            "id": "Cotton, OK"
          },
          {
            "id": "Jefferson, OK"
          },
          {
            "id": "Harper, OK"
          },
          {
            "id": "Woods, OK"
          },
          {
            "id": "Alfalfa, OK"
          },
          {
            "id": "Grant, OK"
          },
          {
            "id": "Ellis, OK"
          },
          {
            "id": "Woodward, OK"
          },
          {
            "id": "Major, OK"
          },
          {
            "id": "Garfield, OK"
          },
          {
            "id": "Jackson, OK"
          },
          {
            "id": "Kiowa, OK"
          },
          {
            "id": "Roger Mills, OK"
          },
          {
            "id": "Dewey, OK"
          },
          {
            "id": "Custer, OK"
          },
          {
            "id": "Blaine, OK"
          },
          {
            "id": "Kingfisher, OK"
          },
          {
            "id": "Beckham, OK"
          },
          {
            "id": "Washita, OK"
          },
          {
            "id": "Caddo, OK"
          },
          {
            "id": "Canadian, OK"
          },
          {
            "id": "Grady, OK"
          },
          {
            "id": "Harmon, OK"
          },
          {
            "id": "Greer, OK"
          }
        ]
      },
      "AlertTextShort": {
        "section": "Tornado Watch in effect until May 2 at 10:00PM CDT by NWS."
      },
      "AlertTextLong": {
        "section": "TORNADO WATCH 62 REMAINS VALID UNTIL 10 PM CDT THIS EVENING FOR THE FOLLOWING AREAS IN OKLAHOMA THIS WATCH INCLUDES 27 COUNTIES IN CENTRAL OKLAHOMA CANADIAN GRADY KINGFISHER IN NORTHERN OKLAHOMA"
      }
    }
  ]
}

export default TestWeatherEvents



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/weatherAlert.js